export const PORT_RANGE_SECTION_EVENT =
	'canvas-agent:port-range:section';
export const PORT_RANGE_FOCUS_EVENT =
	'canvas-agent:port-range:focus';
export const PORT_RANGE_CREATE_MODAL_EVENT =
	'canvas-agent:port-range:create-modal';
export const PORT_RANGE_DELETE_MODAL_EVENT =
	'canvas-agent:port-range:delete-modal';
